import { api as factory } from '@travelnest/entities';

import old from '../api';
import IEntities from './entities';

export const api = factory<IEntities>({
	// Optionally configure each service's baseURL and prefix.
	// See ui-entities docs
	serviceSpec: {
		default: {
			baseUrl: process.env.API_URL || '//API_URL_ENV_UNSET_ERROR'
		},
	},
	transformers: [async (config) => {
		const user = await old.authentication.getCurrentUser();
		const session = user ? user.getSignInUserSession() : null;
		const jwt = session ? session.getIdToken().getJwtToken() : '';
		config.headers = {
			'Authorization': `Bearer ${jwt}`,
			...config.headers
		};
		return config;
	}]
});

export type IApi = typeof api;
